// This is a skeleton starter React page generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import {PageParamsProvider as PageParamsProvider__} from "@plasmicapp/react-web/lib/host";
import GlobalContextsProvider from "../components/plasmic/redesigned_credit_storm_landing_app_credit_storm_2/PlasmicGlobalContextsProvider";

import {PlasmicTerms} from "../components/plasmic/redesigned_credit_storm_landing_app_credit_storm_2/PlasmicTerms";
import {useRouter} from "next/router";
import {PlasmicQueryDataProvider} from "@plasmicapp/react-web/lib/query";

function Terms() {
    // Use PlasmicTerms to render this component as it was
    // designed in Plasmic, by activating the appropriate variants,
    // attaching the appropriate event handlers, etc.  You
    // can also install whatever React hooks you need here to manage state or
    // fetch data.
    //
    // Props you can pass into PlasmicTerms are:
    // 1. Variants you want to activate,
    // 2. Contents for slots you want to fill,
    // 3. Overrides for any named node in the component to attach behavior and data,
    // 4. Props to set on the root node.
    //
    // By default, PlasmicTerms is wrapped by your project's global
    // variant context providers. These wrappers may be moved to
    // Next.js Custom App component
    // (https://nextjs.org/docs/advanced-features/custom-app).

    return (
        <GlobalContextsProvider>
            <PlasmicQueryDataProvider>
                <PageParamsProvider__
                    route={useRouter()?.pathname}
                    params={useRouter()?.query}
                    query={useRouter()?.query}
                >
                    <PlasmicTerms />
                </PageParamsProvider__>
            </PlasmicQueryDataProvider>
        </GlobalContextsProvider>
    );
}

export default Terms;
